import { createIcon } from '@mote/ui/components/icon'
import { defaultProps } from './defaultProps'

export const ArrowUpRightIcon = createIcon({
  displayName: 'ArrowUpRightIcon',
  path: [
    <path
      d='m16.004 9.414-8.607 8.607-1.414-1.414L14.589 8H7.004V6h11v11h-2V9.414Z'
      fill='currentColor'
    />
  ],
  defaultProps: defaultProps
})
